var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 0.750086C7.36831 0.750086 5.77325 1.23394 4.41655 2.14046C3.05984 3.04698 2.00242 4.33546 1.378 5.84295C0.753575 7.35044 0.590197 9.00924 0.908525 10.6096C1.22685 12.2099 2.01259 13.6799 3.16637 14.8337C4.32016 15.9875 5.79016 16.7732 7.39051 17.0916C8.99085 17.4099 10.6497 17.2465 12.1571 16.6221C13.6646 15.9977 14.9531 14.9402 15.8596 13.5835C16.7661 12.2268 17.25 10.6318 17.25 9.00008C17.255 7.91529 17.045 6.84026 16.6321 5.83708C16.2193 4.83391 15.6118 3.92246 14.8447 3.15539C14.0776 2.38831 13.1662 1.78081 12.163 1.36797C11.1598 0.955125 10.0848 0.745121 9 0.750086ZM9 15.7501C7.66498 15.7501 6.35994 15.3542 5.2499 14.6125C4.13987 13.8708 3.27471 12.8166 2.76382 11.5832C2.25293 10.3498 2.11925 8.9926 2.3797 7.68323C2.64015 6.37385 3.28303 5.17112 4.22703 4.22711C5.17104 3.28311 6.37377 2.64024 7.68314 2.37979C8.99251 2.11933 10.3497 2.25301 11.5831 2.7639C12.8165 3.27479 13.8707 4.13996 14.6124 5.24999C15.3541 6.36002 15.75 7.66506 15.75 9.00008C15.7402 10.7873 15.0258 12.4984 13.7621 13.7622C12.4984 15.0259 10.7872 15.7402 9 15.7501Z",
    fill: "#545ADC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 7.5C8.80109 7.5 8.61032 7.57902 8.46967 7.71967C8.32902 7.86032 8.25 8.05109 8.25 8.25V12.75C8.25 12.9489 8.32902 13.1397 8.46967 13.2803C8.61032 13.421 8.80109 13.5 9 13.5C9.19891 13.5 9.38968 13.421 9.53033 13.2803C9.67098 13.1397 9.75 12.9489 9.75 12.75V8.25C9.75 8.05109 9.67098 7.86032 9.53033 7.71967C9.38968 7.57902 9.19891 7.5 9 7.5Z",
    fill: "#545ADC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 6C9.41421 6 9.75 5.66421 9.75 5.25C9.75 4.83579 9.41421 4.5 9 4.5C8.58579 4.5 8.25 4.83579 8.25 5.25C8.25 5.66421 8.58579 6 9 6Z",
    fill: "#545ADC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationBlueIcon);
export default __webpack_public_path__ + "static/media/Information-blue-icon.b3af4bc9de8ca83c934f34cb79ffc2c5.svg";
export { ForwardRef as ReactComponent };